var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card",class:{ active: _vm.activeFilter.key === _vm.filter.key },on:{"click":function($event){return _vm.toggleStatFilter(_vm.filter)}}},[_c('span',{staticClass:"stat-card__label mr-2"},[_vm._v(_vm._s(_vm.filter.name))]),_vm._v(" "),_c('span',{staticClass:"stat-card__number"},[_vm._v(_vm._s(_vm.stats[_vm.filter.key]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }